import http from 'src/app/http';


const confirmRequest = ({ userId, activationToken }) =>
  http.put(`/users/${userId}/confirmed`, { token: activationToken });


export default {
  confirmRequest
};
